<template>
  <div>
    <my-table
      :data="data"
      :loading="loading"
      :headers="headers"
      :query="query"
      @edit="handleEdit"
      @create="handleCreate"
      @refresh="handleRefresh"
      @search="handleSearch"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
      create-text="Бичих"
    >
    </my-table>
    <send
      :item="item"
      v-model:visible="visible"
      @save-success="handleSaveSuccess"
    />
  </div>
</template>
<script>
import send from './send.vue'
import listData from '../../utils/listData'
import listMethods from '../../utils/listMethods'
import * as _ from 'lodash'
export default {
  components: {
    send
  },
  data () {
    return {
      ...listData,
      listApiUrl: '/contracts/sms',
      headers: [{
        name: 'phone',
        caption: 'Дугаар'
      }, {
        name: 'text',
        caption: 'Утга'
      }, {
        name: 'success',
        caption: 'Амжилттай эсэх?',
        width: '100px',
        type: 'Success'
      }, {
        name: 'errText',
        caption: 'Алдаа'
      }, {
        name: 'customer.firstName',
        caption: 'Харилцагч'
      }, {
        name: 'contract.regNo',
        caption: 'Гэрээ',
        width: '140'
      }, {
        name: 'createdAt',
        caption: 'Илгээсэн огноо',
        type: 'Date',
        width: '90'
      }, {
        name: 'createdBy.firstName',
        caption: 'Илгээсэн',
        width: '90'
      }],
      query: { page: 1, limit: 15, sort: [{ name: 'createdAt', type: 'DESC' }], search: [] },
      visible: false,
      item: null
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    ...listMethods,
    handleCreate () {
      this.item = null
      this.visible = true
    },
    handleEdit (val) {
      this.item = this.data[0].find(c => c.id === val)
      this.visible = true
    },
    handleSaveSuccess () {
      this.handleRefresh()
    }
  }
}
</script>
